module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Regular-4553f9e4.svg";